import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GrBox } from "../../layout";
import { palette } from "../../../theme/palette";
import styled from "@emotion/styled";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import classNames from "classnames";
const StyledLinearProgress = styled(LinearProgress)(({ height }) => ({
    height: height,
    borderRadius: height,
    backgroundColor: `${palette.black}0F`,
    "& .MuiLinearProgress-bar": {
        borderRadius: height,
        backgroundColor: palette.darkNavy040,
    },
}));
function GrProgressBar(props) {
    var _a;
    const { value } = props;
    return _jsx(StyledLinearProgress, { variant: "determinate", value: value, height: (_a = props.height) !== null && _a !== void 0 ? _a : 10 });
}
function GrProgressCircle(props) {
    const { value, size, className, color = "blue", thickness = 8, variant = "determinate" } = props;
    return (_jsxs(GrBox, { className: classNames("GrProgressCircle", className), style: {
            position: "relative",
            height: size,
            width: size,
        }, children: [_jsx(CircularProgress, { variant: "determinate", value: 100, thickness: thickness, sx: { color: props.hasBackgroundColor ? (color === "white" ? `${palette.white}66` : `${palette.black}0F`) : "transparent" }, size: size }), _jsx(CircularProgress, { variant: variant, value: value, thickness: thickness, sx: { position: "absolute", top: 0, left: 0, color: color === "blue" ? palette.darkNavy040 : palette[color] }, size: size })] }));
}
export { GrProgressBar, GrProgressCircle };
//# sourceMappingURL=GrProgress.js.map